import { FragmentOf, graphql } from "../gql-tada"

export const customerAddressFragment = graphql(`
  fragment CustomerAddress on Address @_unmask {
    __typename
    id
    fullName
    phoneNumber
    streetLine1
    streetLine2
    city
    province
    postalCode
    country {
      id
      code
      name
    }
    company
    defaultShippingAddress
    defaultBillingAddress
  }
`)

export const activeCustomerFragment = graphql(
  `
    fragment ActiveCustomer on Customer @_unmask {
      id
      title
      firstName
      lastName
      emailAddress
      phoneNumber
      addresses {
        ...CustomerAddress
      }
    }
  `,
  [customerAddressFragment],
)

export type ActiveCustomer = FragmentOf<typeof activeCustomerFragment>

export const GET_ACTIVE_CUSTOMER = graphql(
  `
    query getActiveCustomer {
      activeCustomer {
        ...ActiveCustomer
      }
    }
  `,
  [activeCustomerFragment],
)

export const GET_ACTIVE_CUSOMTER_ORDERS = graphql(`
  query activeCustomerOrderList($orderListOptions: OrderListOptions) {
    activeCustomer {
      orders(options: $orderListOptions) {
        totalItems
        items {
          code
          state
          createdAt
          orderPlacedAt
          currencyCode
          subTotal
          subTotalWithTax
          total
          totalWithTax
          shippingWithTax
          shippingLines {
            priceWithTax
          }
          taxSummary {
            taxBase
            taxTotal
          }
          discounts {
            amountWithTax
          }
          fulfillments {
            trackingCode
          }
          lines {
            id
            quantity
            discountedLinePriceWithTax
            discountedUnitPriceWithTax
            fulfillmentLines {
              quantity
              fulfillment {
                state
                updatedAt
              }
            }
            featuredAsset {
              name
              source
              preview
            }
            productVariant {
              name
              sku
              currencyCode
              priceWithTax
              product {
                slug
              }
            }
          }
          payments {
            id
            method
            state
            amount
            createdAt
            refunds {
              id
              state
              total
              createdAt
            }
          }
        }
      }
    }
  }
`)
